/*
 * Jira Ticket:
 * Created Date: Thu, 16th Apr 2020, 13:16:43 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { useForm } from 'react-final-form';
import { Send } from '@material-ui/icons';
import { TemplateToolbar } from 'Components/Toolbars';
import { TextButton as InviteButton } from 'Components/Buttons';
import { isValidCSV } from 'utils/validation';
import { readFilePromise } from 'utils';

const parseCSVFile = async (file, translate) => {
  const CSVOutput = await readFilePromise(file);
  return isValidCSV(CSVOutput, translate);
};

const InviteUserToolbar = ({
  organisationId,
  notify,
  translate,
  setShowConfirmModal,
  setConfirmModalContent,
  setShowErrorModal,
  setDialogErrorText,
  setFormDataToSubmit,
  ...props
}) => {
  const form = useForm();

  const handleInviteUserRequest = async () => {
    const inviteMethod = form.getFieldState('multiUser').value;
    const formState = form.getState();
    let emails = [];

    if (Object.keys(formState.errors).length > 0) {
      props.handleSubmit(); // we call this to trigger a 'touchAll' on the form
      return notify('ra.message.invalid_form', 'warning');
    }

    if (inviteMethod === 'MANUAL') {
      const emailValue = form.getFieldState('email').value;
      if (emailValue) {
        const emailList = emailValue.split(',');
        emailList.forEach(email => emails.push(email.trim()));
      }
    } else if (inviteMethod === 'BULK') {
      const CSVFieldValue = form.getFieldState('inviteCSV').value;
      if (CSVFieldValue) {
        const { rawFile } = CSVFieldValue;
        const csvData = await parseCSVFile(rawFile, translate);
        if (csvData.result) {
          emails = csvData.data;
        } else {
          setFormDataToSubmit(null);
          setShowConfirmModal(false);
          setConfirmModalContent('');
          setDialogErrorText(csvData.error);
          return setShowErrorModal(true);
        }
      }
    }
    setFormDataToSubmit({
      ...formState.values,
      organisationId,
      emails: [...emails],
    });
    setConfirmModalContent(
      translate('resources.User.fields.inviteUserConfirmModalContent', {
        noEmails: String(emails.length),
        listEmails: String(emails.join(', ')),
      })
    );
    return setShowConfirmModal(true);
  };

  return (
    <TemplateToolbar
      children={
        <InviteButton
          key="invite-button"
          label={translate('actions.invite')}
          onClick={() => {
            handleInviteUserRequest();
          }}
          icon={<Send />}
        />
      }
      {...props}
    />
  );
};

export default InviteUserToolbar;
